class TicketBilling {
  constructor({
    id = '',
    uuid = '',
    eticket = '',
    reservationCode = '',
    nombreCliente = '',
    fechaEmision = '',
    tipo = '',
    tipoDocumento = '',
    tipoDocDesc = '',
    total = '',
    tipoVenta = '',
    isFacturable = null,
    codigoFacturable = '',
    descripcionCodigoFacturable = '',
    motivoCodigoFacturable = '',
    rfc = '',
    fop = [],
  }) {
    this.id = id;
    this.uuid = uuid;
    this.eticket = eticket;
    this.reservationCode = reservationCode;
    this.nombreCliente = nombreCliente;
    this.fechaEmision = fechaEmision;
    this.tipo = tipo;
    this.tipoDocumento = tipoDocumento;
    this.tipoDocDesc = tipoDocDesc;
    this.total = total;
    this.tipoVenta = tipoVenta;
    this.isFacturable = isFacturable;
    this.codigoFacturable = codigoFacturable;
    this.descripcionCodigoFacturable = descripcionCodigoFacturable;
    this.motivoCodigoFacturable = motivoCodigoFacturable;
    this.rfc = rfc;
    this.fop = fop;
  }
}

export default TicketBilling;